import { Component } from '../../common';

export default Component;
